<template>
  <div
    class="w-full flex bg-white my-2 justify-center px-6 py-10 height-100 rounded-10px"
  >
    <div class="flex justify-center w-28per items-center">
      <div class="elshadow px-6 w-full py-10 rounded-2xl">
        <div class="text-center">
          <h1 class="fsize22 text-dark font-semibold">
            {{
              (emailAvailability.status && passwordAvailability) || !email
                ? "Sign In"
                : "Sign Up"
            }}
          </h1>
          <p class="fsize14 text-gray justify-center pt-2 flex">
            Check your inbox to access this credentials
          </p>
        </div>
        <div class="mt-6">
          <div class="relative">
            <small class="fsize12 bg-white text-dark font-medium"
              >Email ID</small
            >
            <el-input
              placeholder="Email Id"
              v-validate="'required|email|min:3'"
              data-vv-validate-on="input|blur"
              name="email"
              v-model="email"
              class="rounded-xl mt-2"
              :autofocus="true"
            />
            <span
              v-if="(email.length && !emailAvailability.status) || !isActive"
              class="fsize10"
              :class="{
                'text-danger': !emailAvailability.status,
              }"
            >
              {{ emailAvailability.text }}
            </span>
          </div>
          <div
            class="mt-4"
            v-if="
              email.length &&
              emailAvailability.status &&
              !passwordAvailability &&
              isActive
            "
          >
            <div class="relative">
              <small class="fsize12 bg-white text-dark font-medium"
                >New Password</small
              >
              <el-input
                placeholder="New Password"
                v-validate="'required'"
                data-vv-validate-on="blur"
                show-password
                type="password"
                name="password"
                v-model="password"
                class="rounded-xl mt-2"
              />
            </div>
            <div class="mt-4 w-full">
              <div class="flex flex-wrap">
                <h2
                  class="m-1 cust-chips flex items-center gap-1"
                  :class="{ 'chips-active': uperCaseCharacter }"
                >
                  <feather-icon
                    icon="CheckIcon"
                    svgClasses="w-4 h-4"
                    class="font-semibold"
                    :hidden="uperCaseCharacter == false"
                  />
                  1 uppercase
                </h2>
                <h2
                  class="m-1 cust-chips flex items-center gap-1"
                  :class="{ 'chips-active': specialCharacter }"
                >
                  <feather-icon
                    icon="CheckIcon"
                    svgClasses="w-4 h-4"
                    class="font-semibold"
                    :hidden="specialCharacter == false"
                  />
                  1 special character
                </h2>
                <h2
                  class="m-1 cust-chips flex items-center gap-1"
                  :class="{ 'chips-active': pwdLength }"
                >
                  <feather-icon
                    icon="CheckIcon"
                    svgClasses="w-4 h-4"
                    class="font-semibold"
                    :hidden="pwdLength == false"
                  />
                  character length more than 8
                </h2>
                <h2
                  class="m-1 cust-chips flex items-center gap-1"
                  :class="{ 'chips-active': numericCharacter }"
                >
                  <feather-icon
                    icon="CheckIcon"
                    svgClasses="w-4 h-4"
                    class="font-semibold"
                    :hidden="numericCharacter == false"
                  />
                  1 numeric character
                </h2>
              </div>
            </div>
            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Confirm Password</small
              >
              <el-input
                placeholder="Confirm Password"
                class="rounded-xl mt-2"
                data-vv-validate-on="blur"
                v-validate="'required|min:6|min:3'"
                type="password"
                name="confirmPassword"
                v-paste-disabled
                v-model="confirmPass"
                @keyup.native.enter="handleClick"
              />
              <span
                v-if="!confirmPasswordMatched.status"
                class="fsize10"
                :class="{
                  'text-danger': !confirmPasswordMatched.status,
                }"
              >
                {{ confirmPasswordMatched.text }}
              </span>
            </div>
            <div
              class="relative mt-4 fsize10"
              v-if="
                checkEmailDataVersion === true && tempDetails.role === 'Admin'
              "
            >
              <el-checkbox
                :disabled="agreementSigned"
                v-model="terms"
                @change="eSignRequest"
                >Yes, I accept terms and conditions.</el-checkbox
              >
            </div>
          </div>
          <div
            class="relative mt-4"
            v-if="emailAvailability.status && passwordAvailability && isActive"
          >
            <small class="fsize12 bg-white text-dark font-medium"
              >Password</small
            >
            <el-input
              placeholder="Password"
              class="rounded-xl mt-2"
              show-password
              data-vv-validate-on="blur"
              v-validate="'required|min:6|max:10'"
              type="password"
              name="password"
              ref="password"
              v-model="password"
              @keyup.native.enter="handleClick"
            />
            <div
              v-if="
                checkEmailDataVersion === true && tempDetails.role === 'Admin'
              "
              class="relative mt-4 fsize10"
            >
              <!-- && env == 'production' -->
              <el-checkbox
                :disabled="agreementSigned"
                v-model="terms"
                @change="eSignRequest"
                >Yes, I accept terms and conditions.</el-checkbox
              >
            </div>
          </div>
          <div class="flex justify-end w-full mt-2">
            <a
              class="text-primary cursor-pointer text-md px-4 py-2"
              @click="reForget"
            >
              Forgot Password?
            </a>
          </div>
          <div class="mt-4">
            <vs-button
              variant="primary"
              :disabled="!isActive"
              v-loading.fullscreen.lock="fullscreenLoading"
              @click="handleClick"
              class="rounded-full bg-primary border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
            >
              <!-- && env == 'production' -->
              {{
                (emailAvailability.status && passwordAvailability) || !email
                  ? "Login"
                  : "Create Password"
              }}
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script
  type="text/javascript"
  src="https://signdesk.in/api/eSignWidgetLive.js"
></script>
<script>
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
import Vue from "vue";
import axios from "axios";
import jwt from "jsonwebtoken";
import { mapState } from "vuex";
import helloAxios from "@/builder/api/index.js";
import masterAxios from "@/Apicall/masters/masterRepository";
import adminAxios from "@/marcom/Apicall/Repository";
export default {
  data() {
    return {
      email: "",
      password: "",
      confirmPass: "",
      checkbox_remember_me: false,
      result: "",
      emailAvailability: {},
      passwordAvailability: "",
      confirmPasswordMatched: {},
      admin: "",
      terms: false,
      agreementSigned: false,
      agreementPlan: "",
      document_id: "",
      docket_id: "",
      signer_id: "",
      token: "",
      AgreementDatas: {},
      checkEmailDataVersion: false,
      agreementID: "",
      tempDetails: {},
      fullscreenLoading: false,
      isActive: true,
    };
  },

  watch: {
    email: debounce(async function (newValue) {
      const { data } = await adminAxios.post("/users/findUser", {
        email: this.email.toLowerCase(),
      });

      console.log(data.status, "yooo");
      console.log(Object.keys(data.data).length, "yooo");
      if (!Object.keys(data.data).length) {
        console.log("Hello");
        this.emailAvailability = {
          status: false,
          text: "That email does not exists.",
        };
        let url = process.env.VUE_APP_BRAINED_API_URL;
        // console.log(!!data.result.password);
        const { data } = await axios.post(
          url + "brained/user/checkUserAndResellerInMaster",
          {
            email: this.email.toLowerCase(),
            projectName: process.env.VUE_APP_COMMUNITY_NAME,
            projectId:process.env.VUE_APP_PROJECT_ID
          }
        );

        if (data && Object.keys(data.result).length) {
          let roleId;
          if (data.result.newRole == "Reseller") {
            const { data } = await this.$store.dispatch("admin/addRole", {
              name: "Reseller",
              modules: ["Branding", "Builder"],
            });
            console.log(data.data._id, "ROLES");
            roleId = data.data._id;
            await this.$store.dispatch("admin/addUserAsAdmin", {
              name: data.result.username,
              email: data.result.email,
              mobile: data.result.mobile,
              role: roleId,
            });
          }

          if (data.result.newRole == "Admin") {
            this.tempDetails = data.result;
            console.log(data, "USER");
            await this.$store.dispatch("admin/addUserAsAdmin", {
              name: data.result.username,
              email: data.result.email,
              mobile: data.result.mobile,
              role: "Admin",
              resellerId: data.result.projects[0].username,
            });
          }
          this.emailAvailability = {
            status: true,
          };
          this.passwordAvailability = false;
        } else if (data && !Object.keys(data.data).length) {
          this.emailAvailability = {
            status: false,
            text: "That email does not exits.",
          };
        }
      } else if (Object.keys(data.data).length) {
        this.emailAvailability = {
          status: true,
          text: "That email does not exists.",
        };
        if (
          data.data.hasOwnProperty("isActive") &&
          data.data.isActive === false
        ) {
          this.isActive = false;
          this.emailAvailability = {
            status: true,
            text: "That email does not exists.",
          };
        }
        if (
          !!data.data.passwordSet &&
          (data.data.hasOwnProperty("isActive") ? data.data.isActive : true)
        ) {
          this.admin = false;
          this.$nextTick(() => {
            console.log(this.$refs.password, "PASS");
            this.$refs.password.focus();
          });
          this.passwordAvailability = true;
        } else if (!data.data.passwordSet && data.data.isActive) {
          this.admin = false;
          this.passwordAvailability = false;
        }
        this.checkEmailDataVersion = data.data.agreementVersion
          ? data.data.agreementVersion
          : false;
        this.agreementID = data.data.agreementID;
        this.agreementPlan = data.data.agreementPlan;
        this.tempDetails = data.data;
      }
    }),
  },

  methods: {
    reForget() {
      this.$router.push({ name: "forgot-password" });
    },
    // async checkEmail() {
    //   try {
    //     // debounce(async () => {
    //     const emailCheck = {
    //       email: this.email.toLowerCase(),
    //     };
    //     let url = process.env.VUE_APP_BRAINED_API_URL;
    //     const { data } = await helloAxios.post(
    //       "brained/user/checkUserAndResellerInMaster",
    //       emailCheck
    //     );

    //     if (data.success) {
    //       this.emailAvailability = {
    //         status: false,
    //         text: "The email does not exists.",
    //       };
    //       this.passwordAvailability = false;
    //     } else if (!data.success) {
    //       this.emailAvailability = {
    //         status: true,
    //         text: "That email does not exists.",
    //       };
    //       console.log(!!data.result.passwordSet);
    //       if (data.result && data.result && !!data.result.passwordSet) {
    //         this.$nextTick(() => {
    //           console.log(this.$refs.password, "PASS");
    //           this.$refs.password.focus();
    //         });
    //         this.passwordAvailability = true;
    //       } else if (data.result && data.result && !data.result.passwordSet) {
    //         this.passwordAvailability = false;
    //       }
    //     }
    //     // });
    //     // debounce(async function () {

    //     // });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    async handleClick() {
      if (
        // ((this.checkEmailDataVersion === true && this.terms === true) ||
        //   (this.checkEmailDataVersion === false && this.terms === false)) &&
        this.emailAvailability.status &&
        this.passwordAvailability
      ) {
        await this.loginJWT();
        if (this.checkEmailDataVersion === true && this.terms === false) {
          this.$store.commit("admin/SET_AGREEMENT_STATUS", {
            key: "agreementStatus",
            value: true,
          });
        }
      } else if (this.confirmPass === this.password) {
        this.confirmPasswordMatched = {
          status: true,
        };
        await this.createPassword();
      } else {
        this.confirmPasswordMatched = {
          status: false,
          text: "Password does not match",
        };
      }
    },

    async checkLogin() {
      // let token = localStorage.getItem("token");3
      try {
        let token =
          this.$store.state.admin.login && this.$store.state.admin.login.token
            ? this.$store.state.admin.login.token
            : "";
        // If user is already logged in notify
        // console.log(token);
        jwt.verify(token, `p4sta.w1th-b0logn3s3-s@uceundefined`);
        if (token) {
          const brandData = await this.getBrandProfile();
          if (!brandData) {
            this.createBrandProfile();
          } else {
            if (brandData && brandData.isCompleted) {
              this.$router.push({ name: "dashboard" });
            } else {
              this.$router.push({ name: "hello" });
            }
          }
          this.result = true;
        } else {
          this.result = false;
          // await this.$store.commit("RESET_STATE");
        }
      } catch (error) {
        this.result = false;
        await this.$store.commit("RESET_STATE");
      }
    },
    async loginJWT() {
      try {
        this.fullscreenLoading = true;
        // let token = localStorage.getItem("token");
        if (this.result == false) {
          let payload = {
            email: this.email,
            password: this.password,
            projectId:process.env.VUE_APP_PROJECT_ID
          };

          // let { data } = await this.$store.dispatch("admin/UserLogin", payload);
          // console.log(data);
          // let user;
          // if (this.admin)
          //   const user = await masterAxios.post("/marcom/admin/login", payload);
          //   data = user.data
          // else if (!this.admin)
          //   const user = await adminAxios.post("/marcom/admin/login", payload);
          //   data = user.data

          const { data } = this.admin
            ? await masterAxios.post("/marcom/admin/login", payload)
            : await adminAxios.post("/marcom/admin/login", payload);
          this.$store.commit("admin/USER_LOGIN", {
            key: "login",
            value: data.data,
          });
          console.log(data, "DATA");
          if (data.data && data.data.role) {
            this.$store.commit("admin/USER_MODULES", {
              key: "userModules",
              value: data.data.role.modules,
            });
          }
          if (data.data.token) {
            const tokenVerify = jwt.verify(
              data.data.token,
              `p4sta.w1th-b0logn3s3-s@uceundefined`
            );
            console.log(tokenVerify, "TOKEN");

            if (tokenVerify.userEmail === this.email) {
              // localStorage.setItem("token", data.data.token);
              await this.getUserDetails();
              // this.$router.push({ name: "hello" });
              await this.$store.dispatch("billing/getPlan");
              // await this.$store.dispatch("billing/getModules");
              await this.$store.dispatch("billing/myAddOns");

              const brandData = await this.getBrandProfile();
              console.log(brandData, "BRAND");
              if (!brandData) {
                this.createBrandProfile();
              } else {
                if (brandData && brandData.isCompleted) {
                  this.$router.push({ name: "dashboard" });
                } else {
                  this.$router.push({ name: "hello" });
                }
              }

              // console.log(brandData);
            }
          }
          // if (tokenVerify.userEmail === this.email) {
          //   // localStorage.setItem("token", data.data.token);
          //   this.$router.push({ name: "hello" });
          //   await this.getUserDetails(data.data.mobile);
          //   await this.$store.dispatch("admin/getModules");
          // }
          else {
            // if (data.code == 200) {
            //   this.$vs.notify({
            //     color: "warning",
            //     title: data.data.message,
            //     // text: "Changes Saved Successfully",
            //   });
            // } else {
            //   this.$vs.notify({
            //     color: "warning",
            //     title: "Invalid Credentials",
            //     // text: "Changes Saved Successfully",
            //   });
            // }
            this.fullscreenLoading = false;

            this.$vs.notify({
              color: "danger",
              title: "Invalid Credentials",
              // text: "Changes Saved Successfully",
            });
          }
        }
      } catch (err) {
        this.fullscreenLoading = false;

        console.log(err);
      }
    },

    async createPassword() {
      if (this.email != "" && this.password != "") {
        const payload = {
          admin: this.admin,
          email: this.email,
          password: this.password,
        };
        const data = await this.$store.dispatch(
          "admin/createNewPassword",
          payload
        );
        if (data.code == 200) {
          this.email = "";
          this.password = "";
        }
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Empty Fields",
          // text: "Changes Saved Successfully",
        });
      }
    },

    async getUserDetails() {
      return new Promise(async (resolve, reject) => {
        // let loader = this.$loading.show({});
        // if (
        //   !this.$route.query.tel &&
        //   !Object.keys(this.brainedUserDetails).length
        // ) {
        //   loader.hide();
        //   this.logout();
        // }
        try {
          // let project = {};
          // project =
          await this.$store.dispatch("user/getProject");
          if (!Object.keys(this.selectedProject).length) {
            await this.$store.dispatch("user/createProject");
            // localStorage.setItem("community", project.data[0].projectName);
            // this.$store.commit("user/SET_PROJECT", project.data[0]);
            // this.$store.commit("user/SET_USER_DETAILS", project.data.result);
          }
          // else {
          // project = await axios.post(
          //   "https://brained-hello-api.aiab.in/brained/user/viewUser",
          //   {
          //     mobile: mobile,
          //   }
          // );
          // project =
          //  await this.$store.dispatch("user/createProject");
          // console.log(project, "PROJECT");
          // if (project && Object.keys(project.data).length) {
          //   this.toggleProjectModal(true);
          // } else {
          //   // localStorage.setItem("community", project.data);
          //   // this.$store.commit(
          //   //   "user/SET_PROJECT",
          //   //   project.data
          //   // );
          // }
          // this.$store.commit("user/SET_USER_DETAILS", project.data.result);
          // }
          // const { data } = await axios.post(
          //   "https://brained-hello-api.aiab.in/brained/user/viewUser",
          //   {
          //     mobile: mobile,
          //   }
          // );
          // this.setZohoName(
          //   data.result.username,
          //   data.result.mobile,
          //   data.result.email
          // );
          // if (data.result.projects.length > 1) {
          //   this.toggleProjectModal(true);
          // } else {
          //   localStorage.setItem(
          //     "community",
          //     data.result.projects[0].projectName
          //   );

          // this.$store.commit("user/SET_PROJECT", data.result.projects[0]);

          // this.$router.push({ name: "newScreen" });
          // }
          // this.$store.commit("user/SET_USER_DETAILS", data.result);

          //  else {
          //   this.loadzohoChat();
          // }

          resolve("");
          // loader.hide();
        } catch (error) {
          console.log(error);
          reject(error);
          // loader.hide();
        }
      });
    },

    // loginJWT() {
    //   this.$router.push({ name: "main" });
    // },

    registerUser() {
      let token = localStorage.getItem("token");
      if (token == "") {
        this.$router.push({ name: "page-register" }).catch(() => {});
      }
    },

    async getBrandProfile() {
      let payloadBrand = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      const { data } = await this.$store.dispatch(
        "brandProfile/getBrandProfile",
        payloadBrand
      );
      console.log(this.brandProfile);
      return data[0];
    },

    async createBrandProfile() {
      let payloadBrand = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      const data = await this.$store.dispatch(
        "brandProfile/createBrandProfile",
        payloadBrand
      );
      console.log(data);
      this.$router.push({ name: "hello" });
    },

    async eSignRequest() {
      this.$vs.loading();
      try {
        if (this.terms === true) {
          this.terms = false;
          let payload = {
            agreementId: this.agreementID,
            email: this.tempDetails.email,
            username: this.tempDetails.name,
            mobile: this.tempDetails.mobile,
          };
          let data = await this.$store.dispatch(
            "agreement/geteSignRequest",
            payload
          );
          this.docket_id = data.data.docket_id;
          this.signer_id = data.data.signer_info[0].signer_id;
          this.document_id = data.data.signer_info[0].document_id;

          console.log(data, "esignData");
          await this.eSignWidget(data.data.agreementPlan, data.data.version);
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
      }
    },
    async eSignWidget(plan, version) {
      var self = this;
      let signDetails = {};
      var clientData = {
        document_id: self.document_id,
        signer_id: self.signer_id,
        docket_id: self.docket_id,
        id: process.env.VUE_APP_SIGN_DESK_APP_ID,
        getWidgetToken: async function (result) {
          // function will return widget token
          console.log(result, "TOKEN");
          self.token = result;
          let payload = {
            widget_token: result,
            time_stamp: Date.now(),
            // time_stamp: "2023-04-26",
            docket_id: self.docket_id,
          };
          signDetails = await self.$store.dispatch(
            "agreement/geteSignWidget",
            payload
          );
          console.log(signDetails, "LOG");
        },
        signatureStatus: async function (result) {
          // function will return signature status
          if (result.status === "success") {
            await self.$store.dispatch("user/updateProject", {
              projectId: process.env.VUE_APP_ID,
              agreementSigned: {
                version: version,
                selectedPlan: plan,
              },
            });
            self.terms = true;
            self.agreementSigned = true;
          } else if (result.status === "failed") {
            self.terms = false;
          }
        },
        errorLog: function (result) {
          // function will return error
          console.log(result, "ERROR");
        },
      };
      // function call to load Signature Panel
      await esignWidgetCall(clientData);
    },
    async AgreementData() {
      let payload = {
        getAll: true,
        isActive: true,
        published: true,
      };
      let { data } = await this.$store.dispatch(
        "agreement/GetAgreement",
        payload
      );
      this.AgreementDatas = data.data[0];
    },

    async init() {
      await this.$store.dispatch("modules/getModules");

      if (process.env.VUE_APP_COMMUNITY_NAME === "nhrdn") {
        await this.$store.dispatch("user/getVersion", {
          projectName: "brained-admin-vue",
        });
      } else {
        await this.$store.dispatch("user/getVersion", {
          projectName: process.env.VUE_APP_COMMUNITY_NAME,
        });
      }
    },
  },

  computed: {
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("brandProfile", {
      brandProfile: "brandProfile",
    }),
    ...mapState("admin", ["login"]),
    isInvalid() {
      return this.errors.any();
    },
    uperCaseCharacter() {
      return this.password.length && this.password.match(/[A-Z]/g) === null
        ? false
        : this.password.length && this.password.match(/[A-Z]/g).length
        ? true
        : false;
    },

    numericCharacter() {
      return this.password.length && this.password.match(/[0-9]/g) === null
        ? false
        : this.password.length && this.password.match(/[0-9]/g).length
        ? true
        : false;
    },

    specialCharacter() {
      return this.password.length &&
        this.password.match(/[!,@,#,$,%,^,&,*]/g) === null
        ? false
        : this.password.length &&
          this.password.match(/[!,@,#,$,%,^,&,*]/g).length
        ? true
        : false;
    },

    pwdLength() {
      return this.password.length > 7 ? true : false;
    },

    env() {
      return process.env.NODE_ENV;
    },

    // confirmPasswordMatched() {
    //   return this.confirmPass.length >= this.password.length &&
    //     this.password.length
    //     ? this.confirmPass === this.password
    //     : "";
    // },
  },
  async mounted() {
    console.log("Login Mount");
    setTimeout(async () => {
      await this.init();
    }, 200);
    await this.checkLogin();
    await this.AgreementData();
  },
};
//paste-disable is custom name of directive like v-model,v-bind etc
Vue.directive("paste-disabled", {
  // el is taken bcuz element is el-input
  bind(el) {
    el.addEventListener("paste", (e) => {
      // from prevenetdefault it prevent from pasting
      e.preventDefault();
    });
  },
});
</script>
<style>
.col-ffc1 {
  color: #ffc148 !important;
}
.col-56 {
  color: #f6f6f6 !important;
}
.col-4f {
  color: #4f4f4f !important;
}
.bg-f9 {
  background: #f9f9f9 !important;
}
.third-fonts {
  line-height: 19px;
  font-size: 17px !important;
  color: #000 !important;
}
.second-fonts {
  line-height: 19px;
  font-size: 17px !important;
}
.bordb {
  border-bottom: 1px solid #ececec;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: rgb(205, 49, 151) !important;
  color: #fff !important;
  border-radius: 4px !important;
  border: none !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
}
.bg-light-green {
  background: rgba(111, 205, 87, 0.16) !important;
  color: #6fcd57 !important;
}
.greenh {
  background: #6fcd57 !important;
  width: 3px !important;
  height: 3px !important;
  border-radius: 50% !important;
}
.bg-light-orange {
  background: rgba(255, 143, 11, 0.13) !important;
  color: #ff8f0b !important;
}
.cust-chips {
  font-size: 10px;
  color: grey;
  font-weight: 500;
  background: #f4f5f6;
  padding: 6px 10px;
  border-radius: 18px;
}
.chips-active {
  background-color: rgba(40, 199, 111, 0.12) !important;
  color: #2dce89 !important;
  font-weight: 600;
}
.w-28per {
  width: 28%;
}
</style>
